import Cards from '../components/Cards.jsx';
import projectsData from '../data/projects.json';

export default function Projects() {
  return (
    <section className="page-content">
      {/* <h1><em>Projects</em></h1> */}
      {/* <hr /> */}
      <p>
        A collection of creative endeavors — music releases, collaborative experiments, and
        artistic projects brought to life by beautiful minds.
      </p>
      <Cards data={projectsData} />
    </section>
  );
}
